<template>
  <div class="container-fluid mx-3 md:mx-10 my-8">
    <div class="client-edit-form">
      <md-dialog-alert
          :md-active.sync="saved"
          md-title="Záznam bol upravený"
          :md-content="`Používateľ s menom <strong>${user.name}</strong> bol úspešne upravený`" />
      
      <md-dialog-confirm
          :md-active.sync="active"
          md-title="Ste si istý ?"
          :md-content="`Chcete uložiť používateľa s menom <strong>${user.name}</strong> ?`"
          md-confirm-text="Potvrdiť"
          md-cancel-text="Zrušiť"
          @md-confirm="saveClient" />
      
      <md-tabs v-if="hasUser" md-sync-route :md-dynamic-height="true">
        <md-tab id="tab-home" md-label="Upraviť používateľa" :to="{'name': 'settings'}" exact>
          
          <div class="flex flex-wrap w-full -mx-4">
            <div class="w-1/2 px-4">
              <div class="flex flex-wrap -mx-4">
                <div class="w-full px-4">
                  <md-field>
                    <label>Meno</label>
                    <md-input v-model="user.name" />
                  </md-field>
                </div>
                
                <div class="w-1/2 px-4">
                  <md-field>
                    <label>Telefón</label>
                    <md-input type="phone" v-model="user.phone" />
                  </md-field>
                </div>
                <div class="w-1/2 px-4">
                  <md-field>
                    <label>E-mail</label>
                    <md-input type="email" v-model="user.email" />
                  </md-field>
                </div>
                
                <div class="w-1/2 px-4">
                  <md-field>
                    <label>Heslo</label>
                    <md-input v-model="user.password" type="password"></md-input>
                  </md-field>
                </div>
                
                <div class="w-1/2 px-4">
                  <md-field>
                    <label>Heslo potvrdenie</label>
                    <md-input v-model="user.password_confirm" type="password"></md-input>
                  </md-field>
                </div>
                
                <div class="w-full px-4">
                  <div class="my-4">
                    <label class="text-gray-500 font-medium text-md mb-3 block">Farba</label>
                    <div class="flex">
                      <div v-for="color in colors" class="flex flex-col">
                        <span class="font-bold uppercase text-center block text-black" style="font-size: 10px;">{{ color.slice(0, 4) }}</span>
                        
                        <div v-for="i in intensity" :key="i"
                             class="w-10 h-10 border-2 border-transparent cursor-pointer hover:border-black flex items-center justify-center text-xs font-bold text-white leading-tight text-center"
                             @click="() => pickColor(color, i)"
                             :class="`bg-${color}-${i} ${ user.color === `${color}-${i}` ? 'border-black' : '' }`">
                          {{ getInicials(user) }}
                          {{ i }}
                        </div>
                      </div>
                    </div>
  
                  </div>
                </div>
              
              </div>
            </div>
          
          </div>
          
          <div class="justify-end flex">
            <md-button :to="{name: 'users.list'}">Späť na zoznam</md-button>
            <md-button @click="() => this.active = true" class="md-primary">Uložiť</md-button>
          </div>
        </md-tab>
      
      </md-tabs>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import {getInicials} from "../utils";
  
  export default {
    name: "Settings",
    
    data: () => ({
      saved: false,
      active: false,
      colors: [
        'yellow', 'orange', 'red', 'hellboy', 'pork', 'beef', 'pink', 'purple',
        'indigo', 'sky', 'blue', 'aqua', 'teal', 'green', 'hulk', 'lime',
        'olive', 'gray', 'grey'
      ],
      intensity: [200, 300, 400, 500, 600, 700, 800, 900]
    }),
    
    computed: {
      ...mapState({
        user: state => state.account.user
      }),
      
      hasUser() {
        return Object.keys(this.user).length > 0;
      }
    },
    
    methods: {
      getInicials(u) {
        return getInicials(u.name, u.image)
      },
      saveClient() {
        this.$store.dispatch("saveUser", this.user)
            .then(() => {
              this.saved = true;
            })
      },
      
      pickColor(color, intensity) {
        this.user.color = `${color}-${intensity}`;
      }
    }
  }
</script>

<style scoped>

</style>